export default __webpack_public_path__ + "static/media/10.8c8dc941.jpg";